import { render, staticRenderFns } from "./Examiner.vue?vue&type=template&id=132bcf7b&scoped=true&"
import script from "./Examiner.vue?vue&type=script&lang=js&"
export * from "./Examiner.vue?vue&type=script&lang=js&"
import style0 from "./Examiner.vue?vue&type=style&index=0&id=132bcf7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bcf7b",
  null
  
)

export default component.exports